/**
 * @file
 * @copyright  2017 Subscribe-HR
 */

import ConditionAbstract from './ConditionAbstract';
import Condition from './Condition';

/**
 * Subscribe-HR entity condition list
 */
export default class ConditionList extends ConditionAbstract {

  /**
   * Entity grid decorator decorator
   * @param {string} type, AND or OR
   * @param {array} list of conditions
   */
  constructor(type = null, list = []) {
    super(type);
    this.list = list;
  }

  /**
   * Entity grid decorator decorator
   * @param {ConditionAbstract} condition - condition or condition list
   */
  addCondition = (condition) => {
    this.list.push(condition);
  }

  /**
   * Entity grid decorator decorator
   * @return {array}
   */
  getList = () => {
    return this.list;
  }

  /**
   * Returns object representation of condition
   * @return {object}
   */
  getDefinition = () => {
    const result = [];
    for (let i = 0; i < this.list.length; i += 1) {
      result.push(this.list[i].getDefinition());
    }
    return result.length > 0 ? {Type: this.getType(), List: result} : null;
  }

  /**
   * Loads data from object
   * @param {object} obj
   */
  load = (obj) => {
    for (let i = 0; i < obj.List.length; i += 1) {
      let conditionItem = null;
      if (obj.List[i].List !== undefined) {
        conditionItem = new ConditionList(obj.List[i].Type);
        conditionItem.load(obj.List[i]);
      } else {
        conditionItem = new Condition(
          obj.List[i].Type,
          obj.List[i].EntityName,
          obj.List[i].FieldName,
          obj.List[i].Operator,
          obj.List[i].Value,
        );
      }
      this.addCondition(conditionItem);
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/common/js-subscribe-sdk/lib/Entities/ConditionList.js